import React, { useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";

// Icon
import {
  Search,
  X,
  Heart,
  ShoppingCart,
  MoreHorizontal,
  Eye,
  FileEdit,
  Trash2,
  ChevronLeft,
  ChevronRight,
  SearchX,
  Loader2,
  List,
  LayoutGrid,
} from "lucide-react";

import { Dropdown } from "Common/Components/Dropdown";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";

// react-redux
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import {
  getJewelleries as onGetJewelleries,
  deleteJewellery as onDeleteJewellery,
  getJewelleryMetals as onGetJewelleryMetals,
  countDiamondPrices as onCountDiamondPrices,
} from "slices/thunk";
import { ToastContainer } from "react-toastify";
import {
  resetFilterOptions,
  setFilterOptions,
  setIsEditing,
} from "slices/jewellery/reducer";
import FilterProducts from "./Components/filterProducts";
import { useJewelleryContext } from "context/JwelleryPriceContext";
import JewelleryProduct from "./Components/jewelleryProduct";

const gender = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

const jewelleryProduct = {
  _id: "66d82cb64c0f17e33815bebb",
  sku: "rose-gold-tulip-ring",
  title: "Rose Gold Tulip Ring",
  description:
    "Classic and refined, this exquisite tulip rose gold solitaire engagement ring features a shape of your choice  diamond that sits within a four prong basket setting. Handcrafted in Hatton Gardens, London. Centre Diamond Not Included Setting Only ",
  gender: "female",
  category: "Engagement Ring",
  subcategory: "Hidden Halo",
  shape: "Radiant",
  media: [
    {
      _id: "66d82cb54c0f17e33815beb7",
      type: "gold",
      images: [
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442756687.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442769131.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442785742.webp",
      ],
      videos: [],
      __v: 0,
    },
    {
      _id: "66d82cb54c0f17e33815beb8",
      type: "rosegold",
      images: [
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442760636.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442773778.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442790309.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442801681.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1733228238126.jpg",
      ],
      videos: [],
      __v: 0,
    },
    {
      _id: "66d82cb54c0f17e33815beb9",
      type: "whitegold",
      images: [
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442764304.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442780345.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442794053.webp",
        "https://shineonpreprod.blob.core.windows.net/jewellery-images/1725442805697.webp",
      ],
      videos: [],
      __v: 0,
    },
  ],
  metal: { "14k": 3, "18k": 3, platinum: 3 },
  tags: [],
  status: "scheduled",
  visibility: "public",
  diamonds: [
    {
      shape: "princess",
      color: "ghi",
      clarity: "vs",
      carat: 0.2,
      pieces: 1,
      _id: "66f81bd695bdd8b9f8b80d2e",
    },
  ],
  createdAt: "2024-09-04T09:47:34.005Z",
  updatedAt: "2025-02-19T16:52:15.788Z",
  __v: 0,
  bandWidth: 1,
  discount: {
    _id: "672b5e56a4198e35a4d007a8",
    type: "percentage",
    value: 10,
    startDate: "2024-12-27T18:30:00.000Z",
    endDate: "2024-12-30T18:30:00.000Z",
    createdAt: "2024-11-06T12:17:26.400Z",
    updatedAt: "2024-12-28T07:33:04.398Z",
    __v: 0,
  },
  isDiscounted: true,
  slug: "rose-gold-tulip-ring",
};

const Products = () => {
  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Jewellery,
    (state) => ({
      dataList: state.productGrid,
      jewelleries: state.jewelleries,
      totalCount: state.totalCount,
      filterOptions: state.filterOptions,
      categories: state.categories,
      subcategories: state.subcategories,
      isLoading: state.isLoading,
    })
  );

  const { shapes } = useSelector((state: any) => state.Diamond);

  const {
    jewelleries,
    totalCount,
    categories,
    isLoading,
    subcategories,
    filterOptions,
  } = useSelector(selectDataList);

  // const list = true;
  const [data, setData] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();
  const [list, setList] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);

  const [drawerEnd, setDrawerEnd] = useState<boolean>(false);
  const drawerEndToggle = () => setDrawerEnd(!drawerEnd);

  const handleApplyFilters = async () => {
    // Dispatch the action to fetch filtered jewelleries based on filterOptions
    const payload = {
      filterOptions: {
        ...filterOptions,
      },
      page: currentPage,
      pageSize, // Page size to maintain pagination
    };
    dispatch(onGetJewelleries(payload));
    drawerEndToggle();
  };

  const getSelectedNames = (
    type: "category" | "subcategory" | "shape" | "gender" | "onlyDiscounted",
    filterOptions: any,
    data: any[]
  ) => {
    if (type === "onlyDiscounted") {
      return filterOptions[type] ? [{ name: "Discounted", type }] : [];
    }

    const selectedValues = filterOptions[type]
      ? type === "gender"
        ? [filterOptions[type]] // If it's gender, use it as a single value
        : filterOptions[type].split(",") // For other types, split by commas
      : [];

    return selectedValues
      .map((value: string) => {
        const item = data.find(
          (item: any) => item._id === value || item.value === value
        );

        return item
          ? { name: item.name || item.shape || item.label, type }
          : null;
      })
      .filter((item: any) => item !== null); // Filter out null items
  };

  const selectedNames = [
    ...getSelectedNames("category", filterOptions, categories),
    ...getSelectedNames("subcategory", filterOptions, subcategories),
    ...getSelectedNames("shape", filterOptions, shapes),
    ...getSelectedNames("gender", filterOptions, gender),
    ...getSelectedNames("onlyDiscounted", filterOptions, []),
  ];

  useEffect(() => {
    setData(jewelleries);
  }, [jewelleries]);

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (item: any) => {
    setDeleteModal(true);
    if (item._id) {
      setEventData(item);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteJewellery(eventData._id));
      setDeleteModal(false);
    }
  };

  const handleRemoveLabel = (
    name: string,
    type: "category" | "subcategory" | "shape" | "gender" | "onlyDiscounted"
  ) => {
    if (type === "onlyDiscounted") {
      if (filterOptions.onlyDiscounted) {
        // Directly update the state to set `onlyDiscounted` to false
        const updatedFilterOptions = {
          ...filterOptions,
          onlyDiscounted: false, // Turn off discounted filtering
        };

        // Dispatch the updated filter options
        dispatch(setFilterOptions(updatedFilterOptions));

        // Pass the updated filter options and fetch products
        const payload = {
          filterOptions: updatedFilterOptions,
          page: currentPage,
          pageSize,
        };

        dispatch(onGetJewelleries(payload));
      }
      return;
    }

    const selectedIds =
      filterOptions[type] && typeof filterOptions[type] === "string"
        ? type === "gender"
          ? [filterOptions[type]] // If it's gender, use it as a single value
          : filterOptions[type].split(",") // For other types, split by commas
        : [];

    const labelToRemove = (data: any[]) => {
      if (type === "gender") {
        // For gender, compare against the value
        const genderItem = data.find((item: any) => item.label === name);
        return genderItem ? genderItem.value : null;
      }

      const item = data.find((item: any) => item.name === name);
      return item ? item._id : null;
    };

    const updatedIds = selectedIds.filter(
      (id: string) =>
        id !==
        labelToRemove(
          type === "category"
            ? categories
            : type === "subcategory"
            ? subcategories
            : type === "shape"
            ? shapes
            : type === "gender"
            ? gender
            : []
        )
    );

    const payload = {
      filterOptions: {
        ...filterOptions,
        [type]: updatedIds.join(","),
      },
      page: currentPage,
      pageSize,
    };

    dispatch(
      setFilterOptions({
        ...filterOptions,
        [type]: updatedIds.join(","),
      })
    );
    dispatch(onGetJewelleries(payload));
  };

  const filterSearchData = (e: any) => {
    if (e.key === "Enter") {
      const search = e.target.value;

      const payload = {
        filterOptions: {
          ...filterOptions,
          search,
        },
        page: currentPage,
        pageSize,
      };
      dispatch(onGetJewelleries(payload));
      dispatch(
        setFilterOptions({
          ...filterOptions,
          search: search, // Set the new search value
        })
      );
    }
  };

  const toCamelCase = (str: any) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+|\b\w)/g, (match: any, index: number) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase())
      .replace(/(?:^\w|[A-Z]|\b\w|\s+|\b\w)/g, (match: any, index: number) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, "")
      .replace(/_/g, "")
      .replace(/-/g, "");
  };

  const handleResetFilters = () => {
    const payload = {
      pageSize,
      page: currentPage,
    };
    dispatch(resetFilterOptions());
    dispatch(onGetJewelleries(payload));
  };

  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(totalCount / pageSize);

  // const getPages = () => Array.from({ length: totalPages }, (_, i) => i + 1);
  const getPages = () => {
    if (totalPages <= 5)
      return Array.from({ length: totalPages }, (_, i) => i + 1);

    const pages: (number | "...")[] = [1]; // Always show the first page

    if (currentPage > 3) pages.push("...");

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) pages.push("...");

    pages.push(totalPages); // Always show the last page

    return pages;
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const payload = {
      filterOptions: {
        ...filterOptions,
      },
      page: currentPage,
      pageSize,
    };
    dispatch(onGetJewelleries(payload));
  }, [dispatch, currentPage]);

  const btnFav = (ele: any) => {
    if (ele.closest("a").classList.contains("active")) {
      ele.closest("a").classList.remove("active");
    } else {
      ele.closest("a").classList.add("active");
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Grid View" pageTitle="Products" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      {isLoading ? (
        <div className="relative flex items-center justify-center min-h-full">
          <div className="flex justify-center fixed top-[50%]">
            <Loader2 className="size-[35px] ltr:mr-2 rtl:ml-2 animate-spin" />
          </div>
        </div>
      ) : (
        <div className="2xl:col-span-9">
          <div className="flex flex-wrap items-center gap-2">
            <p className="grow">
              Showing all <b>{totalCount}</b> items results
            </p>
            <div className="relative">
              <input
                type="text"
                className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Search by title"
                autoComplete="off"
                onKeyDown={(e) => filterSearchData(e)}
                defaultValue={filterOptions?.search || ""}
              />
              <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
            </div>
            <div className="flex gap-2 shrink-0 items-center">
              {/* <Dropdown className="relative dropdown">
                <Dropdown.Trigger
                  href="#!"
                  className="bg-white text-custom-500 btn border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:bg-zink-700 dark:hover:bg-custom-500 dark:ring-custom-400/20 dark:focus:bg-custom-500 dropdown-toggle"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                >
                  Sort by: <b className="font-medium">Highest Price</b>
                  <ChevronDown className="inline-block size-4 ltr:ml-1 rtl:mr-1" />
                </Dropdown.Trigger>

                <Dropdown.Content
                  placement="right-end"
                  className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md dropdown-menu min-w-[10rem] dark:bg-zink-600"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to="#!"
                    >
                      Lowest Price
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to="#!"
                    >
                      Highest Price
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to="#!"
                    >
                      Hight to Low
                    </Link>
                  </li>
                  <li className="pt-2 mt-2 border-t dark:border-zink-300/50">
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to="#!"
                    >
                      Low to High
                    </Link>
                  </li>
                </Dropdown.Content>
              </Dropdown> */}

              <Link to="/jewellery-list-view">
                <button
                  type="button"
                  id="listView"
                  className={`flex items-center justify-center size-[37.5px] p-0 text-sky-500 btn bg-sky-100 hover:text-white hover:bg-sky-600 focus:text-white focus:bg-sky-600 [&.active]:text-white [&.active]:bg-sky-600 dark:bg-sky-500/20 dark:text-sky-400 dark:hover:bg-sky-500 dark:hover:text-white dark:focus:bg-sky-500 dark:focus:text-white dark:[&.active]:bg-sky-500 dark:[&.active]:text-white dark:ring-sky-400/20 ${
                    !list && "active"
                  }`}
                  // onClick={() => setList(false)}
                >
                  <List className="size-4" />
                </button>
              </Link>
              <button
                type="button"
                id="gridView"
                className={`flex items-center justify-center size-[37.5px] p-0 text-sky-500 btn bg-sky-100 hover:text-white hover:bg-sky-600 focus:text-white focus:bg-sky-600 [&.active]:text-white [&.active]:bg-sky-600 dark:bg-sky-500/20 dark:text-sky-400 dark:hover:bg-sky-500 dark:hover:text-white dark:focus:bg-sky-500 dark:focus:text-white dark:[&.active]:bg-sky-500 dark:[&.active]:text-white dark:ring-sky-400/20 ${
                  list && "active"
                }`}
                onClick={() => setList(true)}
              >
                <LayoutGrid className="size-4" />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={drawerEndToggle}
              >
                Filter
              </button>
            </div>
          </div>
          {selectedNames.length > 0 && (
            <div className="flex items-center gap-3 mt-3">
              {selectedNames.map(({ name, type }, index) => (
                <span className="px-2.5 py-0.5 text-sm font-medium rounded-full border bg-slate-100 border-slate-300 text-slate-500 inline-flex items-center dark:bg-zink-800 dark:border-zink-500 dark:text-zink-200">
                  {toCamelCase(name)} {/* High to Low{" "} */}
                  <Link
                    to="#!"
                    className="transition text-slate-500 dark:text-zink-200 hover:text-slate-600 dark:hover:text-zink-100"
                    onClick={() => handleRemoveLabel(name, type)}
                  >
                    <X className="size-3 ltr:ml-1 rtl:mr-1" />
                  </Link>
                </span>
              ))}
              <Link
                to="#!"
                className="px-2.5 py-0.5 text-sm font-medium rounded border bg-transparent border-transparent text-slate-500 transition hover:bg-slate-200 dark:bg-zink-800 dark:hover:bg-zink-600 dark:text-zink-200"
                onClick={() => handleResetFilters()}
              >
                All Clear
              </Link>
            </div>
          )}

          <div
            // className={`grid grid-cols-1 gridView mt-5 md:grid-cols-2 [&.gridView]:grid-cols-1 xl:grid-cols-4 group [&.gridView]:xl:grid-cols-1 gap-x-5`}
            className={`grid grid-cols-1 mt-5 md:grid-cols-2 [&.gridView]:grid-cols-1 xl:grid-cols-4 group [&.gridView]:xl:grid-cols-1 gap-x-5 ${
              !list && "gridView"
            }`}
            id="cardGridView"
          >
            {(data || [])?.map((item: any, key: number) => (
              <JewelleryProduct item={item} onClickDelete={onClickDelete} />
            ))}
          </div>

          <div className="flex flex-col items-center mb-5 md:flex-row">
            <div className="mb-4 grow md:mb-0">
              <p className="text-slate-500 dark:text-zink-200">
                Showing <b>{jewelleries.length}</b> of <b>{totalCount}</b>{" "}
                Results
              </p>
            </div>
            <ul className="flex flex-wrap items-center gap-2 shrink-0">
              {/* Prev Button */}
              <li>
                <button
                  onClick={() =>
                    currentPage > 1 && onPageChange(currentPage - 1)
                  }
                  disabled={currentPage === 1}
                  className={`inline-flex items-center justify-center bg-white dark:bg-zink-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zink-500 ${
                    currentPage !== 1 ? "hover:text-blue-500" : "text-gray-300"
                  }`}
                >
                  <ChevronLeft />
                </button>
              </li>
              {/* Page Numbers */}
              {getPages().map((page) => (
                <li key={page}>
                  {page === "..." ? (
                    <span className="inline-flex items-center justify-center h-8 px-3 text-gray-400">
                      ...
                    </span>
                  ) : (
                    <button
                      onClick={() => onPageChange(page as number)}
                      className={`inline-flex items-center justify-center bg-white dark:bg-zink-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zink-500 text-slate-500 dark:text-zink-200 ${
                        currentPage === page
                          ? "bg-blue-500 text-blue-500"
                          : "hover:bg-gray-200"
                      }`}
                    >
                      {page}
                    </button>
                  )}
                </li>
              ))}
              {/* Next Button */}
              <li>
                <button
                  onClick={() =>
                    currentPage < totalPages && onPageChange(currentPage + 1)
                  }
                  disabled={currentPage === totalPages}
                  className={`inline-flex items-center justify-center bg-white dark:bg-zink-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zink-500 ${
                    currentPage !== totalPages
                      ? "hover:text-blue-500"
                      : "text-gray-300"
                  }`}
                >
                  <ChevronRight />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
      {!data.length && !isLoading && (
        <div className="relative flex items-center justify-center min-h-full">
          <div className="text-center fixed top-[50%]">
            <div className="flex justify-center">
              <SearchX size={100} stroke="#afafaf" />
            </div>
            <div className="flex justify-center font-bold text-lg">
              No Result Found
            </div>
          </div>
        </div>
      )}
      <FilterProducts
        filterOptions={filterOptions}
        drawerEnd={drawerEnd}
        drawerEndToggle={drawerEndToggle}
        handleApplyFilters={handleApplyFilters}
        handleResetFilters={handleResetFilters}
      />
    </React.Fragment>
  );
};

export default Products;
